import { createAction, createReducer } from '@reduxjs/toolkit';

const INITIAL_STATE = {
  infos: {
    PAGINATION: {},
    TOTAL_CARTAO_DEBITO: 0,
    TOTAL_CREDITO: 0,
    TOTAL_DEBITO: 0,
    TOTAL_DEPOSITO: 0,
    TOTAL_EMPRESTIMO: 0,
    TOTAL_PAGAMENTO: 0,
    TOTAL_PIX: 0,
    TOTAL_TARIFAS: 0,
    TOTAL_TRANSACAO_INTERNA_CREDITO: 0,
    TOTAL_TRANSACAO_INTERNA_DEBITO: 0,
    TRANSACOES: [],
    mensagem: '',
  },
};

export const dailyMovementsActionLoading = createAction(
  'DAILYMOVEMENTS_ACTION_LOADING',
);
export const dailyMovementsActionSuccess = createAction(
  'DAILYMOVEMENTS_ACTION_SUCCESS',
);
export const dailyMovementsActionError = createAction(
  'DAILYMOVEMENTS_ACTION_ERROR',
);

export default createReducer(INITIAL_STATE, {
  [dailyMovementsActionLoading.type]: (state, payload) => {
    return {
      ...state,
      loadingDailyMovements: true,
    };
  },
  [dailyMovementsActionSuccess.type]: (state, { payload }) => {
    return {
      ...state,
      loadingDailyMovements: false,
      infos: payload,
    };
  },
  [dailyMovementsActionError.type]: (state, payload) => {
    return {
      ...state,
      loadingDailyMovements: false,
      error: true,
    };
  },
});
